import { useEffect } from "react";

const setMeta = (name, content) => {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const SEO = ({ title, description, canonical, jsonLd }) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) setMeta("description", description);
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
    }
    if (jsonLd) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "page-jsonld";
      document.getElementById("page-jsonld")?.remove();
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
      return () => script.remove();
    }
  }, [title, description, canonical, jsonLd]);
  return null;
};
